<template>
    <div class="container">
        <md-card class="request-status">
            <md-card-content>
                <div class="text-center">
                    <h4 v-if="!message.length">checking...</h4>
                    <h4 else>{{message}}</h4>
                </div>
            </md-card-content>
	    </md-card>
    </div>
</template>
<script>
import API from "../services/API";
export default {
    name: 'ConfigureOutlook',
    props: {
        state: {
            type: String,
            required: true
        },
        code: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            fullPage: true,
            api: new API(),
            message: ''
        }
    },
    beforeCreate() {
        if (!this.$route.query.code || !this.$route.query.state) {
            this.$router.push('/');
        }
    },
    async created() {
        await this.api
	        .post(`communities/${this.$route.query.state}/outlook/confirm_auth`, {
	          code: this.code
	        }).then(async response => {
                this.$router.push(`/communities/${this.$route.query.state}`);
	        });
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfigureOutlook.vue